import type { StoredAudioDevice } from '../../../electron/common/audioTypes';
import type { AudioInputDevice } from './audioDeviceTypes';

/**
 * Label first, id second: Chromium's device ids are bound to the browser profile and therefore to
 * the Windows user, so on a shared PC the same microphone has a different id per user. The id only
 * disambiguates devices that share a label.
 */
export function findStoredDevice<T extends AudioInputDevice>(
  devices: T[],
  stored: StoredAudioDevice | null | undefined
): T | undefined {
  if (!stored) return undefined;
  const sameLabel = devices.filter((device) => device.label === stored.label);
  return sameLabel.find((device) => device.deviceId === stored.deviceId) ?? sameLabel[0];
}
